import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/** Digital download: store + listing + optional quantity (no variant). */
export class DigitalIntentBuilder extends StoreScopedIntentBuilder {
  listing(listingId: string): this {
    this.root.param('listing_id', listingId);
    return this;
  }

  quantity(qty: number): this {
    this.root.param('qty', qty);
    return this;
  }
}
